import React from "react"
import ContentHome from "../components/ContentHome"

const HomeTemplate = ({pageContext}) => {
  return <ContentHome {...pageContext}></ContentHome>
}

export default HomeTemplate
